module.exports = __webpack_public_path__ + "img/fullstop.ffcd1ba.png";